/* A.B. Ferramenta — bozza home ArchitettoWeb
   Nessuna dipendenza. Tutto è progressive enhancement: senza questo file
   la pagina resta completamente leggibile e tutti i contatti funzionano. */
(function () {
  'use strict';

  var ready = function (fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  };

  ready(function () {
    /* Ogni sezione è avvolta nel proprio <div class="ab">: le ricerche vanno
       fatte sull'intero documento, non dentro il primo wrapper, altrimenti
       tutte le sezioni dopo l'hero restano invisibili. */
    if (!document.querySelector('.ab')) { return; }
    var root = document;

    /* ---------- 1. rivelazione allo scroll ----------
       rootMargin a 0: un margine negativo crea una zona morta in fondo
       alla pagina e l'ultima sezione può non rivelarsi mai. */
    var items = root.querySelectorAll('.ab-rv');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px', threshold: 0.12 });
      Array.prototype.forEach.call(items, function (el) { io.observe(el); });
    } else {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('is-in'); });
    }

    /* ---------- 2. barra fissa mobile ---------- */
    var sticky = root.querySelector('.ab-sticky');
    if (sticky) {
      var onScroll = function () {
        if (window.scrollY > 420) { sticky.classList.add('is-on'); }
        else { sticky.classList.remove('is-on'); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* ---------- 3. stato di apertura in tempo reale ----------
       Gli orari stanno in `data-ab-orari` sull'elemento, così restano
       modificabili dall'editor del tema senza toccare il codice.
       Formato: un giorno per punto e virgola, da lunedì a domenica;
       intervalli separati da virgola, orari senza due punti (0830-1230). */
    var openEls = root.querySelectorAll('[data-ab-open]');
    if (openEls.length) {
      var now = new Date();
      var mins = now.getHours() * 60 + now.getMinutes();
      var idx = (now.getDay() + 6) % 7;           // lunedì = 0
      var host = root.querySelector('[data-ab-orari]');
      var spec = host ? host.getAttribute('data-ab-orari') : '';
      var perDay = spec ? spec.split(';') : [];
      var todaySpec = perDay[idx] || '';
      var isOpen = false;
      var closesAt = '';
      var opensAt = '';

      todaySpec.split(',').forEach(function (range) {
        var p = range.split('-');
        if (p.length !== 2) { return; }
        var a = parseInt(p[0], 10), b = parseInt(p[1], 10);
        if (isNaN(a) || isNaN(b)) { return; }
        var am = Math.floor(a / 100) * 60 + (a % 100);
        var bm = Math.floor(b / 100) * 60 + (b % 100);
        var fmt = function (v) {
          return String(Math.floor(v / 100)) + ':' + ('0' + (v % 100)).slice(-2);
        };
        if (mins >= am && mins < bm) {
          isOpen = true;
          closesAt = fmt(b);
        } else if (mins < am && !opensAt) {
          opensAt = fmt(a);
        }
      });

      Array.prototype.forEach.call(openEls, function (el) {
        var txt = el.querySelector('[data-ab-open-text]');
        var dot = el.querySelector('.ab-dot');
        if (isOpen) {
          if (txt) { txt.textContent = 'Aperto ora · chiudiamo alle ' + closesAt; }
        } else {
          if (txt) {
            txt.textContent = opensAt
              ? 'Chiuso · riapriamo alle ' + opensAt
              : 'Ora chiusi · scrivici su WhatsApp';
          }
          if (dot) { dot.classList.add('ab-dot--off'); }
        }
      });
    }

    /* evidenzia la riga di oggi nella tabella orari */
    var today = root.querySelector('.ab-orari [data-ab-day="' + ((new Date().getDay() + 6) % 7) + '"]');
    if (today) { today.classList.add('is-today'); }
  });
})();
